export const trackingEvents = {
  PAGE: {
    VIEWED: 'all_workers.page.viewed',
  },
  DOWNLOAD_CSV_BUTTON: {
    CLICKED: 'all_workers.download_csv_button.clicked',
  },
}
